import { useCallback } from "react";

import { useAppDispatch } from "utilities/hooks/general";

import {
  SnackNotification,
  SnackVariant,
  addNotification,
} from "Common/Snackbar";

type Message = Omit<SnackNotification, "variant" | "id">;

export interface UseSnackbar {
  notifySuccess: (message: Message) => void;
  notifyError: (message: Message) => void;
  notifyInfo: (message: Message) => void;
  notifyWarning: (message: Message) => void;
}

export const useSnackbar = (): UseSnackbar => {
  const dispatch = useAppDispatch();

  const notify = useCallback(
    (message: Message, variant: SnackVariant = "success") => {
      void dispatch(
        addNotification({
          ...message,
          variant,
        })
      );
    },
    [dispatch]
  );

  const notifySuccess = useCallback(
    (message: Message) => notify(message, "success"),
    [notify]
  );
  const notifyError = useCallback(
    (message: Message) => notify(message, "error"),
    [notify]
  );
  const notifyInfo = useCallback(
    (message: Message) => notify(message, "info"),
    [notify]
  );
  const notifyWarning = useCallback(
    (message: Message) => notify(message, "warning"),
    [notify]
  );

  return { notifySuccess, notifyError, notifyInfo, notifyWarning };
};
